import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ChevronUp } from "lucide-react";
import { scrollToTop } from "../lib/scroll";
import { useLang } from "../lib/i18n";

/**
 * Bouton discret — remonte en haut après un peu de scroll.
 */
export const BackToTop = () => {
  const { t } = useLang();
  const reduce = useReducedMotion();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          data-testid="back-to-top"
          initial={reduce ? false : { opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduce ? undefined : { opacity: 0, y: 10 }}
          transition={{ duration: reduce ? 0 : 0.25 }}
          onClick={scrollToTop}
          aria-label={t.common.backToTop}
          className="fixed bottom-6 right-6 z-[8000] inline-flex h-10 w-10 items-center justify-center rounded-full border border-copper/65 bg-canvas/85 text-copper backdrop-blur-sm hover:border-copper hover:text-copper-light hover:bg-section transition-colors duration-300 shadow-[0_4px_18px_-8px_rgba(0,0,0,0.8)]"
        >
          <ChevronUp size={18} strokeWidth={1.75} aria-hidden />
        </motion.button>
      )}
    </AnimatePresence>
  );
};
